const WebGLTest2 = {
  title: 'webGLTest2',
  defaultMaterial: 'MeshPhongMaterial',
  commonModels: ['/assets/exterior.glb'],
  backgroundModel: '/assets/background.glb',
  cubeMap: '/assets/StdSky_IEM/',
  refCubeMap: '/assets/20200827_refCubemap/',
  dirLightIntensity: 1,
  subDirLightIntensity: 0.2,
  ambientLightIntensity: 0.4,
  envIntensity: 0.4,
  initialViewName: 'exterior',
  views: {
    floor1: {
      models: ['/assets/floor1.glb'],
      initCameraPos:{
        x: 27, y: 21, z: -18
      },
      initCameraAngle: {
        azimuth: 1.88,
        polar: 1.37,
      }
    },
    floor2: {
      models: ['/assets/floor2.glb'],
      initCameraPos:{
        x: 9, y: 50, z: 24
      },
      initCameraAngle: {
        azimuth: -0.13295846971394495,
        polar: 1.28,
      }
    },
    exterior: {
      models: [],
      initCameraPos:{
        x: -135, y: 88, z: 171
      },
      initCameraAngle: {
        azimuth: -0.68,
        polar :1.36,
      }
    }
  }
}


export default {
  WebGLTest2: WebGLTest2
}
